module.exports = __webpack_public_path__ + "static/img/26天府.69cc53a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo/26天府.jpg
// module id = EcAz
// module chunks = 1